import { createAsyncThunk } from '@reduxjs/toolkit';
import ax from 'services/apiService';

// menu/account_list
export const getCandidDashboard = createAsyncThunk('candid-dashboard-list-grid', async () => {
    try {
        const { data } = await ax.get(`api/api/master_data/dashboard_candidate`);
        return data;
    } catch (error: any) {
        // return custom error message from API if any
        if (error.response && error.response.data) {
            return error.response.data;
        } else {
            return error.message;
        }
    }
});

// master_data/dashboard_examinfo
export const getDashboardInfo = createAsyncThunk('candid-getDashboardInfo-list-grid', async () => {
    try {
        const { data } = await ax.get(`api/api/master_data/dashboard_examinfo`);
        return data;
    } catch (error: any) {
        // return custom error message from API if any
        if (error.response && error.response.data) {
            return error.response.data;
        } else {
            return error.message;
        }
    }
});
// new dashboard menu/dashboard
export const getDashboard = createAsyncThunk('new-dashboard-account', async (payload: any, { rejectWithValue }) => {
    try {
        const { data } = await ax.post(`api/api/menu/dashboard`, payload);
        return data;
    } catch (error: any) {
        // return custom error message from API if any
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        } else {
            return rejectWithValue(error.message);
        }
    }
});

// Account/dashUpcomingExam/1
export const getDashUpcomingExam = createAsyncThunk('dashboard-upcoming-exam', async (id: any, { rejectWithValue }) => {
    try {
        const { data } = await ax.get(`api/api/Account/dashUpcomingExam/${id}`);
        return data;
    } catch (error: any) {
        // return custom error message from API if any
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        } else {
            return rejectWithValue(error.message);
        }
    }
});
export const getDashboardGraph = createAsyncThunk('get-dashboard-gr', async (payload: any, { rejectWithValue }) => {
    try {
                const { data } = await ax.post(`api/api/Exam/get_dashboard_graph`, payload);
                return data;
            } catch (error: any) {
                // return custom error message from API if any
                if (error.response && error.response.data) {
                    return rejectWithValue(error.response.data);
                } else {
                    return rejectWithValue(error.message);
                }
            }
        });

export const getCurrentMonthExams = createAsyncThunk('get-current-month-exam', async (payload: any, { rejectWithValue }) => {
    try {
                const { data } = await ax.post(`api/api/Exam/get_current_month_exams`, payload);
                return data;
            } catch (error: any) {
                // return custom error message from API if any
                if (error.response && error.response.data) {
                    return rejectWithValue(error.response.data);
                } else {
                    return rejectWithValue(error.message);
                }
            }
        });
                export const getDashCardCount = createAsyncThunk('exam-dashboard-count', async (payload: { id: any; tenentId: any }, { rejectWithValue }) => {
                    try {
                        const { data } = await ax.get(`api/api/Exam/get_exam_dashboard_counts/${payload.id}/${payload.tenentId}`);
                        return data;
                    } catch (error: any) {
                        // return custom error message from API if any
                        if (error.response && error.response.data) {
                            return rejectWithValue(error.response.data);
                        } else {
                            return rejectWithValue(error.message);
                        }
                    }
                });
                export const getUnattendedExamList = createAsyncThunk('unattended-exam-dashboard', async (payload: { id: any; tenentId: any }, { rejectWithValue }) => {
                    try {
                        const { data } = await ax.get(`api/api/Exam/get_candidate_exams/${payload.id}/${payload.tenentId}`);
                        return data;
                    } catch (error: any) {
                        // return custom error message from API if any
                        if (error.response && error.response.data) {
                            return rejectWithValue(error.response.data);
                        } else {
                            return rejectWithValue(error.message);
                        }
                    }
                });